// Zentrale Definition der Wachbereitschaften / Zugehörigkeiten.
// Muss inhaltlich zu src/services/wachbereitschaft.js (Backend) passen.
// Die Reihenfolge von WACHBEREITSCHAFT_VALUES ist zugleich die fachliche
// Anzeige-/Gruppierungsreihenfolge (z. B. in der Logbuch-Statistik).
export const WACHBEREITSCHAFT_VALUES = [
  '1_wb',
  '2_wb',
  'nicht_handlungssicher',
  'frw_1',
  'frw_2',
  'frw_4',
  'frw_5',
  'frw_6',
  'frw_7',
  'frw_8',
  'flb',
  'rds',
  'fws',
];

export const WACHBEREITSCHAFT_LABELS = {
  '1_wb': '1. Wachbereitschaft',
  '2_wb': '2. Wachbereitschaft',
  nicht_handlungssicher: 'Nicht Handlungssicher',
  frw_1: 'FRW 1',
  frw_2: 'FRW 2',
  frw_4: 'FRW 4',
  frw_5: 'FRW 5',
  frw_6: 'FRW 6',
  frw_7: 'FRW 7',
  frw_8: 'FRW 8',
  flb: 'FLB',
  rds: 'RDS',
  fws: 'FWS',
};

export const WACHBEREITSCHAFT_SHORT_LABELS = {
  ...WACHBEREITSCHAFT_LABELS,
  '1_wb': '1. WB',
  '2_wb': '2. WB',
  nicht_handlungssicher: 'Nicht HS',
};

export const WACHBEREITSCHAFT_OPTIONS = WACHBEREITSCHAFT_VALUES.map((value) => ({
  value,
  label: WACHBEREITSCHAFT_LABELS[value],
}));

export function normalizeWachbereitschaftValue(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) {
    return '';
  }
  // Legacy-Kurzformen aus Altdaten.
  if (normalized === '1') return '1_wb';
  if (normalized === '2') return '2_wb';
  return WACHBEREITSCHAFT_VALUES.includes(normalized) ? normalized : '';
}

export function getWachbereitschaftLongLabel(value, fallback = '') {
  const normalized = normalizeWachbereitschaftValue(value);
  return WACHBEREITSCHAFT_LABELS[normalized] || fallback;
}

export function getWachbereitschaftShortLabel(value, fallback = '') {
  const normalized = normalizeWachbereitschaftValue(value);
  return WACHBEREITSCHAFT_SHORT_LABELS[normalized] || fallback;
}

export function getWachbereitschaftGroupOrder(value) {
  const normalized = normalizeWachbereitschaftValue(value);
  const index = WACHBEREITSCHAFT_VALUES.indexOf(normalized);
  return index === -1 ? WACHBEREITSCHAFT_VALUES.length : index;
}
